import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";
import {
  createBlobContainerFailure,
  createBlobContainerSuccess, createDefaultRoles, createDefaultRolesFailure, createDefaultRolesSuccess,
  createTenant,
  createTenantFailure,
  createTenantSuccess,
  getAllTenants,
  getAllTenantsFailure,
  getAllTenantsSuccess, reCreateDefaultRoles, reCreateDefaultRolesFailure, reCreateDefaultRolesSuccess,
} from "./tenant.action";
import {InternalOnboardService} from "../../data-access/internal-onboard.service";
import {Tenant} from "../../../shared/models/tenant.model";
import { HttpErrorResponse } from "@angular/common/http";


@Injectable()
export class TenantEffects {

  getAllTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAllTenants),
      switchMap(() =>
        this.tenantService.get()
          .pipe(
            map((tenants: Tenant[]) => getAllTenantsSuccess({tenants: tenants})),
            catchError((error) => of(getAllTenantsFailure({ error: error.error })))
          )
      )
    )
  );

  createTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createTenant),
      switchMap((action) =>
        this.tenantService.createTenant(action.tenant)
          .pipe(
            map((newTenant) => createTenantSuccess({
              tenant: newTenant,
              bulkUploadFile: action.bulkUploadFile
            })),
            catchError((error) => of(createTenantFailure({ error: error.error })))
          )
      )
    )
  );

  createBlobContainer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createTenantSuccess),
      switchMap((action) =>
        this.tenantService.createBlobContainer(action.tenant)
          .pipe(
            map((_) => createBlobContainerSuccess({tenant: action.tenant, bulkUploadFile: action.bulkUploadFile})),
            catchError((error: HttpErrorResponse) => of(createBlobContainerFailure({ error: error.error })))
          )
      )
    )
  );

  createDefaultRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createBlobContainerSuccess),
      switchMap((action) =>
        this.tenantService.createDefaultRoles(action.tenant)
          .pipe(
            map((_) => createDefaultRolesSuccess({tenant: action.tenant})),
            catchError((error) => of(createDefaultRolesFailure({ error: error.error })))
          )
      )
    )
  );

  reCreateDefaultRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reCreateDefaultRoles),
      switchMap((action) =>
        this.tenantService.createDefaultRoles(action.tenant)
          .pipe(
            map((_) => reCreateDefaultRolesSuccess({tenant: action.tenant})),
            catchError((error) => of(reCreateDefaultRolesFailure({ error: error.error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private tenantService: InternalOnboardService
  ) {}
}
